var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkBlack = function SvgLinkBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.375,
    height: 19,
    viewBox: "0 0 21.375 19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-external-link-alt",
    "data-name": "Icon awesome-external-link-alt",
    d: "M21.375.891V5.64a.891.891,0,0,1-1.52.63L18.53,4.945,9.493,13.982a.891.891,0,0,1-1.26,0l-.84-.84a.891.891,0,0,1,0-1.26L16.43,2.845,15.105,1.52A.891.891,0,0,1,15.735,0h4.749A.891.891,0,0,1,21.375.891ZM15.1,10.049l-.594.594a.891.891,0,0,0-.261.63v5.352H2.375V4.75h9.8a.891.891,0,0,0,.63-.261L13.4,3.9a.891.891,0,0,0-.63-1.52H1.781A1.781,1.781,0,0,0,0,4.156V17.219A1.781,1.781,0,0,0,1.781,19H14.844a1.781,1.781,0,0,0,1.781-1.781v-6.54A.891.891,0,0,0,15.1,10.049Z",
    fill: "#000"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "link_black.ee6a13e9b525657a795bf13cbcca729d.svg";